import {BaseContainerModel} from "../../base-container.model";
import { bl_wf_md_process_status_RowClass, bl_wf_md_process_status_RowInterface } from "../../../dbschema";

export class WfMdProcessStatusContainerModel extends BaseContainerModel{
  bl_wf_md_process_status: bl_wf_md_process_status_RowInterface = new bl_wf_md_process_status_RowClass();
}
